import { JSX } from 'solid-js/jsx-runtime';
import { mergeProps, splitProps } from 'solid-js';

export const CollapseIcon = (props: JSX.SvgSVGAttributes<SVGSVGElement>) => {
  const merged = mergeProps(
    {
      width: 16,
      height: 16,
    },
    props,
  );

  const [local, rest] = splitProps(merged, ['width', 'height']);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      {...local}
      {...rest}
    >
      <path d="M213.66,53.66,163.31,104H192a8,8,0,0,1,0,16H144a8,8,0,0,1-8-8V64a8,8,0,0,1,16,0V92.69l50.34-50.35a8,8,0,0,1,11.32,11.32ZM112,136H64a8,8,0,0,0,0,16H92.69L42.34,202.34a8,8,0,0,0,11.32,11.32L104,163.31V192a8,8,0,0,0,16,0V144A8,8,0,0,0,112,136Z" />
    </svg>
  );
};
